/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemPublicationWithRelations } from '../../models/item-publication-with-relations';

export interface AdminFindById$Params {
  id: string;
  inventoryId: string;
}

export function adminFindById(http: HttpClient, rootUrl: string, params: AdminFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ItemPublicationWithRelations>> {
  const rb = new RequestBuilder(rootUrl, adminFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ItemPublicationWithRelations>;
    })
  );
}

adminFindById.PATH = '/admin/item-publications/{id}';
